import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User, ShoppingBag } from 'lucide-react';

interface FooterProps {
    activeTab: string;
    setActiveTab: React.Dispatch<React.SetStateAction<string>>;
}

const DashboardIcon = ({ isActive }: { isActive: boolean }) => (
    <svg
        viewBox="0 0 64 64"
        strokeWidth={3}
        className={`w-7 h-7 transition-colors duration-300 scale-110 ${isActive ? "stroke-primary" : "stroke-white/60 group-hover:stroke-white"}`}>
        <circle cx="50" cy="13" r="6" className="fill-none" />
        <path d="M10 44L24 24L36 44Z" className="fill-none" />
        <path d="M28 44L40 28L54 44Z" className="fill-none" />
    </svg>
);

export default function NewFooter({ activeTab, setActiveTab }: FooterProps) {
    const navigate = useNavigate();

    const navItems = [
        { path: "/profile", tab: "profile", icon: User, label: "پروفایل", external: false, disable: false },
        { path: "/dashboard", tab: "dashboard", icon: DashboardIcon, label: "داشبورد", external: false, disable: false },
        { path: "/shop/", tab: "shop", icon: ShoppingBag, label: "فروشگاه", external: true, disable: true },
    ];

    return (
        <footer
            dir='ltr'
            className="fixed bottom-0 left-0 right-0 z-50">
            <nav className="flex justify-around items-center w-full max-w-[450px] mx-auto h-[70px] bg-darkbg 
                            border-t-2 border-gray-700
                            backdrop-filter backdrop-blur-lg">

                {navItems.map((item) => {
                    const isActive = activeTab === item.tab;
                    return (
                        <div key={item.tab}
                            onClick={() => {
                                if (!item.disable) {
                                    if (item.external) {
                                        window.location.href = item.path;
                                    } else {
                                        navigate(item.path);
                                        setActiveTab(item.tab);
                                    }
                                }
                            }}
                            className={`flex flex-col items-center justify-center h-full w-full cursor-pointer 
                                         group transition-all duration-300 ${isActive ? 'text-primary' : `${item.disable ? 'text-white/30' : 'text-white/80'}`}`}>

                            <item.icon
                                isActive={isActive}
                                className={`w-6 h-6 transition-colors duration-300 
                                    ${isActive ? "stroke-primary" : "stroke-white/60 group-hover:stroke-white"}`}
                                strokeWidth={1}
                            />


                            {isActive && (
                                <div className="w-8 h-1 bg-primary rounded-full absolute -top-[3px] /* Positioned above icon */ transition-all duration-300"></div>
                            )}
                        </div>
                    );
                })}
            </nav>
        </footer>
    );
}
